import React from "react"
import { Link } from "gatsby"
import Breadcrumbs from "./breadcrumbs"
import type { NavigationItem } from "./navigation"

export interface SubnavProps {
  items: (NavigationItem | null)[] | undefined
}

const Subnav = ({ items }: SubnavProps) => {
  return (
    <nav id="menu-subnav" className="c-subnav">
      <span className="c-subnav__line" />
      <div className="c-subnav__content u-flex o-wrapper">
        {items?.map(item => {
          if (item?.url) {
            return (
              <Link
                key={item.id}
                to={item.url}
                className="c-subnav__item"
                activeClassName="active"
                partiallyActive={item.title !== "Overview"}
              >
                {item.title}
              </Link>
            )
          }
        })}
      </div>
      <Breadcrumbs showFor="mobile" />
    </nav>
  )
}

export default Subnav
